<template>
  <router-view />
</template>

<script>
export default {
  name: "Kpi"
};
</script>

<style></style>
